import { usePagination, DOTS } from "./usePagination";

import style from "./Pagination.css";

// Vielen Dank - https://www.freecodecamp.org/news/build-a-custom-pagination-component-in-react/
const Pagination = (props) => {
  const {
    onPageChange, // callback function invoked with the updated page value when the page is changed
    totalCount, // total count of data
    siblingCount, //optional, minimum number of page buttons to be shown on each side of the current page button
    currentPage,
    pageSize, // number of data per page
  } = props;

  const paginationRange = usePagination({
    currentPage,
    totalCount,
    siblingCount,
    pageSize,
  });

  const totalPages = Math.ceil(totalCount / pageSize);
  // If there are less than 2 times in pagination range we shall not render the component
  if (currentPage === 0 || (paginationRange && paginationRange.length < 2)) {
    return null;
  }

  const onNext = () => {
    if (currentPage === totalPages) return;
    onPageChange(currentPage + 1);
  };

  const onPrevious = () => {
    if (currentPage === 1) return;
    onPageChange(currentPage - 1);
  };

  const isPreviousDisabled = () => {
    if (currentPage === 1) {
      return style.disabledPageNavigation;
    }
  };

  const isNextDisabled = () => {
    if (currentPage === totalPages) return style.disabledPageNavigation;
  };

  const isCurrentPage = (pageNumber) => {
    if (currentPage == pageNumber) return style.selectedPage;
  };

  return (
    <div class={style.paginationContainer}>
      <div
        class={style.arrowContainer + " " + isPreviousDisabled()}
        onClick={onPrevious}
      >
        <div class={style.previousPage}></div>
      </div>
      {paginationRange.map((pageNumber) => {
        if (pageNumber === DOTS) {
          return <div>...</div>;
        }

        // Render our Page Pills
        return (
          <div
            class={style.bubbleContainer + " " + isCurrentPage(pageNumber)}
            onClick={() => onPageChange(pageNumber)}
          >
            {pageNumber}
          </div>
        );
      })}
      <div
        class={style.arrowContainer + " " + isNextDisabled()}
        onClick={onNext}
      >
        <div class={style.nextPage}></div>
      </div>
    </div>
  );
};

export { Pagination };
